import { InHubScanTemporaryListRequest, HubInOutManifestRequest, HubInOutManifestExcelRequest } from "@/domain/entities/HubToHub";

export class HubToHubEndpoints {
  generateInHubScan(): string {
    return `/hydra/v1/hub-manifest/temporary`;
  }
  getListHubManifestTemporary(params: InHubScanTemporaryListRequest): string {
    return `/hydra/v1/hub-manifest/temporary?${params.toQueryString()}`;
  }
  processHubManifest() {
    return `/hydra/v1/hub-manifest`;
  }
  getHubOutManifestList(params: HubInOutManifestRequest): string {
    return `/hydra/v1/hub-out-manifest?${params.toQueryString()}`;
  }
  getHubManifestDetail(id: number) {
    return `/hydra/v1/hub-manifest/${id}`;
  }
  getHubInOutManifestList(params: HubInOutManifestRequest): string {
    return `/hydra/v1/hub-manifest?${params.toQueryString()}`;
  }
  getHubManifestExcel(params: HubInOutManifestExcelRequest) {
    return `/hydra/v1/hub-manifest/${params.id}/xlsx`;
  }
}
